// extracted by mini-css-extract-plugin
export default {"container":"nav_dropdown_content-module__container--3OJCn"};